import React from 'react';
import Switch from '@material-ui/core/Switch';
import PropTypes from 'prop-types';
import { ChipsList } from '../common/chipsList/ChipsList';

export default function CookiesMenuSwitch(props) {
  return (
    <div>
      <div style={{ display: 'flex' }}>
        <span className="section-title-label">
          {props.text}
          {!props.hideSwitch && (
            <Switch color="primary" disabled={props.disabled} checked={props.checked} onChange={props.onChange} />
          )}
        </span>
      </div>
      {props.chipList && <ChipsList items={props.chipList} cookiesInfoUrl={props.cookiesInfoUrl} />}
      <p
        style={{ display: 'block', textAlign: 'justify', margin: '0px 30px 15px 30px' }}
        className="switch-description"
      >
        {props.subtext}
      </p>
    </div>
  );
}

CookiesMenuSwitch.propTypes = {
  text: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  chipList: PropTypes.array,
  subtext: PropTypes.string,
  hideSwitch: PropTypes.bool,
  cookiesInfoUrl: PropTypes.string
};
